import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

/**
 * Helper component that renders a button for choosing a layout.
 */
export const ElementEditorLayoutButton: React.FC<
  React.PropsWithChildren<{
    label: string;
    isActive: boolean;
    onClick: () => void;
    className?: string;
  }>
> = ({ label, isActive, onClick, children, className }) => {
  return (
    <button
      type="button"
      disabled={isActive}
      className={twMerge(
        "border-0.5 flex h-full w-full cursor-pointer flex-col justify-between gap-2 rounded-lg p-2",
        isActive ? "border-primary bg-sky-soft" : "border-border",
      )}
      onClick={onClick}
    >
      <div className="text-default text-xs font-medium">{label}</div>
      <div
        className={twMerge(
          "flex aspect-[6/4] w-full flex-col justify-between rounded-sm p-1",
          isActive ? "bg-white" : "bg-surface",
          className,
        )}
      >
        {children}
      </div>
    </button>
  );
};
